export const translations = {
  en: {
    'region.title': 'Region & Language',
    'region.selectCountry': 'Select your country',
    'region.selectRegion': 'Select region',
    'region.selectLanguage': 'Language',
    'region.international': 'International / Global',
    'region.showGlobal': 'Include major international companies',
    'region.apply': 'Apply',
    'region.allRegions': 'All regions',
    'region.northAmerica': 'North America',
    'region.latinAmerica': 'Latin America & Caribbean',
    'region.europe': 'Europe',
    'region.africa': 'Africa',
    'region.eastAsia': 'East Asia',
    'region.southeastAsia': 'Southeast Asia',
    'region.southAsia': 'South Asia',
    'region.centralAsia': 'Central Asia',
    'region.oceania': 'Oceania',
    'nav.home': 'Home',
    'nav.search': 'Search',
    'nav.pacs': 'Political Finance',
    'nav.about': 'About',
    'home.featuredPeople': 'Prominent Individuals',
    'home.featuredCompanies': 'Featured Companies',
    'home.noDataCountry': 'No data yet for this country. Items are being researched — check back soon.',
    'search.filterCountry': 'Country',
    'search.filterType': 'Type',
    'pacs.title': 'Political Finance Directory',
    'pacs.subtitle': 'Political parties, PACs, and campaign finance entities',
  },
  es: {
    'region.title': 'Región e idioma',
    'region.selectCountry': 'Selecciona tu país',
    'region.selectRegion': 'Seleccionar región',
    'region.selectLanguage': 'Idioma',
    'region.international': 'Internacional / Global',
    'region.showGlobal': 'Incluir grandes empresas internacionales',
    'region.apply': 'Aplicar',
    'region.allRegions': 'Todas las regiones',
    'region.northAmerica': 'América del Norte',
    'region.latinAmerica': 'América Latina y el Caribe',
    'region.europe': 'Europa',
    'region.africa': 'África',
    'region.eastAsia': 'Asia Oriental',
    'region.southeastAsia': 'Sudeste Asiático',
    'region.southAsia': 'Asia del Sur',
    'region.centralAsia': 'Asia Central',
    'region.oceania': 'Oceanía',
    'nav.home': 'Inicio',
    'nav.search': 'Buscar',
    'nav.pacs': 'Finanzas políticas',
    'nav.about': 'Acerca de',
    'home.featuredPeople': 'Personas destacadas',
    'home.featuredCompanies': 'Empresas destacadas',
    'home.noDataCountry': 'Aún no hay datos para este país. Se está investigando — vuelve pronto.',
    'search.filterCountry': 'País',
    'search.filterType': 'Tipo',
    'pacs.title': 'Directorio de finanzas políticas',
    'pacs.subtitle': 'Partidos políticos, comités y entidades de financiación',
  },
  fr: {
    'region.title': 'Région et langue',
    'region.selectCountry': 'Sélectionnez votre pays',
    'region.selectRegion': 'Sélectionner la région',
    'region.selectLanguage': 'Langue',
    'region.international': 'International / Global',
    'region.showGlobal': 'Inclure les grandes entreprises internationales',
    'region.apply': 'Appliquer',
    'region.allRegions': 'Toutes les régions',
    'region.northAmerica': 'Amérique du Nord',
    'region.latinAmerica': 'Amérique latine et Caraïbes',
    'region.europe': 'Europe',
    'region.africa': 'Afrique',
    'region.eastAsia': 'Asie de l\'Est',
    'region.southeastAsia': 'Asie du Sud-Est',
    'region.southAsia': 'Asie du Sud',
    'region.centralAsia': 'Asie centrale',
    'region.oceania': 'Océanie',
    'nav.home': 'Accueil',
    'nav.search': 'Rechercher',
    'nav.pacs': 'Finances politiques',
    'nav.about': 'À propos',
    'home.featuredPeople': 'Personnalités',
    'home.featuredCompanies': 'Entreprises',
    'home.noDataCountry': 'Pas encore de données pour ce pays. Recherche en cours.',
    'search.filterCountry': 'Pays',
    'search.filterType': 'Type',
    'pacs.title': 'Annuaire des finances politiques',
    'pacs.subtitle': 'Partis politiques et entités de financement',
  },
  de: {
    'region.title': 'Region & Sprache',
    'region.selectCountry': 'Land auswählen',
    'region.selectRegion': 'Region auswählen',
    'region.selectLanguage': 'Sprache',
    'region.international': 'International / Global',
    'region.showGlobal': 'Große internationale Unternehmen einbeziehen',
    'region.apply': 'Anwenden',
    'region.allRegions': 'Alle Regionen',
    'region.northAmerica': 'Nordamerika',
    'region.latinAmerica': 'Lateinamerika & Karibik',
    'region.europe': 'Europa',
    'region.africa': 'Afrika',
    'region.eastAsia': 'Ostasien',
    'region.southeastAsia': 'Südostasien',
    'region.southAsia': 'Südasien',
    'region.centralAsia': 'Zentralasien',
    'region.oceania': 'Ozeanien',
    'nav.home': 'Startseite',
    'nav.search': 'Suche',
    'nav.pacs': 'Politische Finanzierung',
    'nav.about': 'Über uns',
    'home.featuredPeople': 'Prominente Personen',
    'home.featuredCompanies': 'Unternehmen',
    'home.noDataCountry': 'Noch keine Daten für dieses Land.',
    'search.filterCountry': 'Land',
    'search.filterType': 'Typ',
    'pacs.title': 'Politisches Finanzverzeichnis',
    'pacs.subtitle': 'Politische Parteien und Finanzierungseinheiten',
  },
  pt: {
    'region.title': 'Região e idioma',
    'region.selectCountry': 'Selecione seu país',
    'region.selectRegion': 'Selecionar região',
    'region.selectLanguage': 'Idioma',
    'region.international': 'Internacional / Global',
    'region.showGlobal': 'Incluir grandes empresas internacionais',
    'region.apply': 'Aplicar',
    'region.allRegions': 'Todas as regiões',
    'region.northAmerica': 'América do Norte',
    'region.latinAmerica': 'América Latina e Caribe',
    'region.europe': 'Europa',
    'region.africa': 'África',
    'region.eastAsia': 'Leste Asiático',
    'region.southeastAsia': 'Sudeste Asiático',
    'region.southAsia': 'Sul da Ásia',
    'region.centralAsia': 'Ásia Central',
    'region.oceania': 'Oceania',
    'nav.home': 'Início',
    'nav.search': 'Buscar',
    'nav.pacs': 'Finanças políticas',
    'nav.about': 'Sobre',
    'home.featuredPeople': 'Pessoas em destaque',
    'home.featuredCompanies': 'Empresas em destaque',
    'home.noDataCountry': 'Ainda não há dados para este país.',
    'search.filterCountry': 'País',
    'search.filterType': 'Tipo',
    'pacs.title': 'Diretório de finanças políticas',
    'pacs.subtitle': 'Partidos políticos e entidades de financiamento',
  },
  zh: {
    'region.title': '地区与语言',
    'region.selectCountry': '选择您的国家',
    'region.selectRegion': '选择地区',
    'region.selectLanguage': '语言',
    'region.international': '国际 / 全球',
    'region.showGlobal': '包括主要国际公司',
    'region.apply': '应用',
    'region.allRegions': '所有地区',
    'region.northAmerica': '北美',
    'region.latinAmerica': '拉丁美洲和加勒比',
    'region.europe': '欧洲',
    'region.africa': '非洲',
    'region.eastAsia': '东亚',
    'region.southeastAsia': '东南亚',
    'region.southAsia': '南亚',
    'region.centralAsia': '中亚',
    'region.oceania': '大洋洲',
    'nav.home': '首页',
    'nav.search': '搜索',
    'nav.pacs': '政治金融',
    'nav.about': '关于',
    'home.featuredPeople': '知名人物',
    'home.featuredCompanies': '特色公司',
    'home.noDataCountry': '该国家暂无数据，正在研究中。',
    'search.filterCountry': '国家',
    'search.filterType': '类型',
    'pacs.title': '政治金融目录',
    'pacs.subtitle': '政党与政治融资实体',
  },
  ja: {
    'region.title': '地域と言語',
    'region.selectCountry': '国を選択',
    'region.selectRegion': '地域を選択',
    'region.selectLanguage': '言語',
    'region.international': '国際 / グローバル',
    'region.showGlobal': '主要な国際企業を含める',
    'region.apply': '適用',
    'region.allRegions': 'すべての地域',
    'region.northAmerica': '北米',
    'region.latinAmerica': 'ラテンアメリカ・カリブ',
    'region.europe': 'ヨーロッパ',
    'region.africa': 'アフリカ',
    'region.eastAsia': '東アジア',
    'region.southeastAsia': '東南アジア',
    'region.southAsia': '南アジア',
    'region.centralAsia': '中央アジア',
    'region.oceania': 'オセアニア',
    'nav.home': 'ホーム',
    'nav.search': '検索',
    'nav.pacs': '政治資金',
    'nav.about': '概要',
    'home.featuredPeople': '著名人',
    'home.featuredCompanies': '注目企業',
    'home.noDataCountry': 'この国のデータはまだありません。',
    'search.filterCountry': '国',
    'search.filterType': 'タイプ',
    'pacs.title': '政治資金ディレクトリ',
    'pacs.subtitle': '政党と政治資金団体',
  },
};

export function t(key, lang = 'en') {
  return translations[lang]?.[key] || translations.en[key] || key;
}
